import React from "react"

interface ReceiptBgProps {
  width: number | string;
  height: number | string;
}

export const ReceiptBg: React.FC<ReceiptBgProps> = ({ width, height }) => {
  return (
    <svg
      style={{ filter: "drop-shadow(33px 32px 64px rgb(0 0 0 / 0.06))" }}
      width={width}
      height={height}
      viewBox="0 0 439 446"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        d="M0.5 0.5H438.5V46.3208C438.5 55.2106 432.954 63.1562 424.609 66.2208C411.533 71.0229 411.533 89.5166 424.609 94.3187C432.954 97.3833 438.5 105.329 438.5 114.219V430C438.5 438.56 431.56 445.5 423 445.5H16C7.43958 445.5 0.5 438.56 0.5 430V114.219C0.5 105.329 6.04644 97.3833 14.3913 94.3187C27.4672 89.5165 27.4672 71.0229 14.3913 66.2208C6.04644 63.1562 0.5 55.2106 0.5 46.3208V0.5Z"
        fill="white"
        stroke="#F7F7F7"
      />
    </svg>
  )
}
